import React,{ useEffect, useState, useCallback, useRef, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, Col, Row, Spinner, Table, CardTitle } from "reactstrap";
import PaginationContent from "../pagination";
import { ButtonDelete, ButtonEdit, ButtonToggle, ButtonView } from "./buttonActions";
import { actions as actionsToast } from "../../redux/actions/toast";
import "./crud.scss";
import Search from "./search";
import SearchTerm from "./searchTerm";
import { useDispatch } from "react-redux";
import ButtonTip from "../buttonTip";

const Crud = ({
  actionAdd,
  baseRoute,
  getList,
  back,
  enableSearchTerm = false,
  config: { columns, actions, paginationType = "scroll" },
  configSearch: { enableSearch = false, attributes = [], dataSearch = [], setDataSearch } = {},
  recordsPerPage,
  skip,
  setSkip,
  limit,
  setLimit,
  sort,
  setSort,
  tableSize,
  titleCrud,
  iconTitle = "fas fa-arrow-circle-right",
  pagination = true,
  legends = null,
  showID = false,
  copyID = false
}) => {
  const [listagem, setListagem] = useState({ rows: [], total: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const history = useHistory();
  
  const dispatch = useDispatch();
  const footerListRef = useRef();

  const getListagem = useCallback(async () => {
    setLoading(true);

    if (pagination === false) {
      skip = 0;
      limit = 99999;
    }

    if (getList) {
      const res = await getList({ skip, limit, sort, search });
      setListagem(res);
    }
    setLoading(false);
  }, [getList, skip, limit, sort, search]);

  const getMoreRows = async () => {
    if (getList) {
      if (!loadingMore) {
        setLoadingMore(true);
        const skip = listagem.rows.length;
        const res = await getList({ skip, limit, sort, search });
        const _listagem = { ...listagem };

        _listagem.rows = _listagem.rows.concat(res.rows);
        _listagem.total = res.total;
        setListagem(_listagem);
        setLoadingMore(false);
      }
    }
  };

  useEffect(() => {
    getListagem();
  }, [getListagem]);

  const nPages = Math.ceil(listagem.total / recordsPerPage);

  const renderRows = () => {
    return listagem.rows?.map((row, index) => {
      return (
        <tr key={row._id}>
          {renderRowsColumns(row)}
          {actions && actions.length > 0 && <td>{renderActions(row)}</td>}
        </tr>
      );
    });
  };

  const renderHeadColumns = () => {
    if (columns) {
      return (
        <>
          {showID && <th scope="col" width={50}>ID</th>}
          {columns.map((c, index) => (
            <th scope="col" key={index} width={c.width || "auto"}>
              <div className="d-flex align-items-center justify-content-between">
                {c.label}
                {!c.field.includes(".") && (
                  <div className="text-secondary d-flex flex-column orderer">
                    <span className={(sort === c.field ? "text-dark " : "") + "cursorPointer"} onClick={() => setSort(c.field)}>
                      ▲
                    </span>
                    <span className={(sort === `-${c.field}` ? "text-dark " : "") + "cursorPointer"} onClick={() => setSort(`-${c.field}`)}>
                      ▼
                    </span>
                  </div>
                )}
              </div>
            </th>
          ))}
        </>
      );
    }
  };

  const converts = {
    toImg: (s) => {
      return <img src={s} className="imgCrud" alt="imagem" />;
    },
    toSimNao: (s) => {
      if(s !== undefined){
        return s ? "Sim" : "Não";
      } else {
        return "-";
      }
    },
  };

  const renderRowsColumns = (row) => {
    if (columns) {
      return (
        <>
          {showID && <td width={50} className={row.deleted ? "rowDeleted" : ""}>{copyID ? toCopyID(row._id) : row._id}</td>}
          {columns.map((c, index) => (
            <td key={index} className={row.deleted ? "rowDeleted" : ""}>
              {renderValue(row, c)}
            </td>
          ))}
        </>
      );
    }
  };

  const renderDeepValue = ({ field, value, c }, index = 0) => {
    const attrs = `${field}`.split(".");
    const newValue = value[attrs[index]];
    if (newValue) {
      if (index < attrs.length - 1) {
        return renderDeepValue({ field, value: newValue, c }, index + 1);
      } else {
        return newValue;
      }
    } else {
      return c.nullValue ?? "-";
    }
  };

  const renderValue = (row, c) => {
    let value = row[c.field];

    if (c.field.includes(".")) {
      value = renderDeepValue({ field: c.field, value: row, c });
    }

    if (c.convert) {
      if (typeof c.convert === "string") {
        value = converts[c.convert](value);
      } else if (typeof c.convert === "function") {
        value = c.convert(value, row, c.convertArgs);
      }
    }

    if (c.prefix) {
      value = `${c.prefix}${value}`;
    }

    if (c.suffix) {
      value = `${value}${c.suffix}`;
    }

    return value;
  };

  const setAfterCallback = (afterCallback) => {
    if (typeof afterCallback === "string") {
      switch (afterCallback) {
        case "refreshList":
          return getListagem;
        default:
          break;
      }
    } else {
      return afterCallback;
    }

    return null;
  };

  const renderAction = (act, row) => {
    if (row.deleted) {
      return <></>;
    }
    const afterCallback = setAfterCallback(act.afterCallback);
    if (act.component) {
      const { component: ButtonAction } = act;
      return <ButtonAction row={row} callback={act.callback || console.log} afterCallback={afterCallback || null} />;
    } else {
      switch (act.action) {
        case "edit":
          return <ButtonEdit row={row} callback={act.callback || defaultEdit} afterCallback={act.afterCallback || null} />;
        case "view":
          return <ButtonView row={row} callback={act.callback || defaultEdit} afterCallback={act.afterCallback || null} />;
        case "toggle":
          return <ButtonToggle row={row} callback={act.callback || console.log} afterCallback={act.afterCallback || getListagem} />;
        case "delete":
          return <ButtonDelete row={row} callback={act.callback || console.log} afterCallback={act.afterCallback || getListagem} />;
        default:
          return <></>;
      }
    }
  };

  const renderActions = (row) => {
    return actions.filter((a) => a.enable && a.visibleInCrud).map((a, index) => <Fragment key={index}>{renderAction(a, row, index)}</Fragment>);
  };

  const canAction = (action) => {
    return actions.find((a) => a.action === action && a.enable);
  };

  const defaultAdd = () => {
    history.push(`${baseRoute}/cadastrar`);
  };

  const defaultEdit = (row) => {
    history.push(`${baseRoute}/editar/${row._id}`);
  };

  const goTop = () => {
    window.scrollTo(0, 0);
  };

  const toCopyID = (id) => {
    return <>
      <ButtonTip
        className="btn-action rounded"
        size="sm"
        outline
        type="button"
        color="info"
        id={"Tooltip-copy-" + id}
        tooltipText={`Clique para copiar: ${id}`}
        onClick={async () => {
          await navigator.clipboard.writeText(id);
          dispatch(actionsToast.successToast(`ID ${id} copiado`));
        }}
      >
      <i className="fas fa-copy"></i>
    </ButtonTip></>
  }

  return (
    <Row>
      {enableSearch && (
        <Col md="12">
          <Card>
            <CardBody>
              <Search getListagem={getListagem} setSearch={setSearch} attributes={attributes} search={search} />
            </CardBody>
          </Card>
        </Col>
      )}

      {enableSearchTerm && (
        <Col md="12">
          <Card>
            <CardBody>
              <SearchTerm getListagem={getListagem} setSearch={setSearch} />
            </CardBody>
          </Card>
        </Col>
      )}

      <Col md="12">
        <Card>
          <CardBody>
            <Row>
              {titleCrud && (
                <Col sm="12">
                  <CardTitle>
                    <i className={iconTitle}></i> {titleCrud}
                  </CardTitle>
                </Col>
              )}
              <Col>
                {loading ? (
                  <div className="text-center mt-3">
                    <Spinner color="danger" />
                  </div>
                ) : (
                  <>
                    {paginationType === "pages" && (
                      <PaginationContent
                        nPages={nPages}
                        currentPage={currentPage}
                        recordsPerPage={recordsPerPage}
                        skip={skip}
                        setSkip={setSkip}
                        total={listagem.total}
                        setCurrentPage={setCurrentPage}
                      />
                    )}
                    <Row>
                      {legends !== null && (
                        <Col>
                          <strong>Legendas:</strong>
                          {legends.map((text,index) => (<div key={index}>*{text}</div>))}
                        </Col>
                      )}
                      <Col className="mt-2 mt-sm-0">
                        <div className="d-flex justify-content-end">
                          {canAction("create") && (
                            <Button type="button" color="success" className="mr-1" onClick={actionAdd || defaultAdd}>
                              <i className="fas fa-plus mr-1"></i>Adicionar
                            </Button>
                          )}
                          <Button type="button" color="info" className="atualizarLista" onClick={getListagem}>
                            <i className="fas fa-sync-alt mr-1"></i>Atualizar Lista
                          </Button>
                          {/* <pre>{JSON.stringify(search,null,2)}</pre> */}
                          {(search.length > 0 || (search.term && search.term.length > 0)) && (
                            <Button type="button" color="secondary" onClick={() => setSearch([])} className="ml-2">
                              <i className="fas fa-undo mr-1"></i>Resetar lista
                            </Button>
                          )}
                          {back && (
                            <Button type="button" color="secondary" onClick={back} className="ml-2">
                              <i className="fas fa-arrow-left"></i> Voltar
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Table responsive bordered striped className="mt-3 crudview" size={tableSize ?? ""}>
                      <thead>
                        {paginationType === "scroll" && (
                          <tr className="border-0">
                            <th colSpan={columns.length + (showID ? 2: 1)} className="border-0">
                              <div className="d-flex align-item-center justify-content-end">
                                Exibindo {listagem.rows.length} / Total: {listagem.total} registros
                              </div>
                            </th>
                          </tr>
                        )}
                        <tr>
                          {renderHeadColumns()}
                          {actions && actions.length > 0 && (
                            <th scope="col" style={{ minWidth: 150 }}>
                              Ações
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>{renderRows()}</tbody>
                      {paginationType === "scroll" && (
                        <tfoot ref={footerListRef}>
                          <tr>
                            <td colSpan={columns.length + 1} height={60} style={{ boxSizing: "border-box" }}>
                              {loadingMore && (
                                <div className="d-flex align-items-center justify-content-center">
                                  <Spinner color="secondary" size={"sm"} />
                                  <span className="ml-1">Carregando mais registros...</span>
                                </div>
                              )}
                              {!loadingMore && (
                                <div className="d-flex align-items-center justify-content-between">
                                  <Button size="sm" color="info" className="rounded" onClick={goTop}>
                                    Ir para o topo
                                  </Button>
                                  <div className="d-flex align-items-center justify-content-end">
                                    <span className="mr-1">
                                      Exibindo {listagem.rows.length} / Total: {listagem.total} registros
                                    </span>
                                    {pagination === true && (
                                      <Button size="sm" color="primary" className="rounded mr-1" onClick={getMoreRows}>
                                        Carregar mais
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </Table>
                    {paginationType === "pages" && (
                      <PaginationContent
                        nPages={nPages}
                        currentPage={currentPage}
                        recordsPerPage={recordsPerPage}
                        skip={skip}
                        setSkip={setSkip}
                        total={listagem.total}
                        setCurrentPage={setCurrentPage}
                      />
                    )}
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default Crud;
